"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumList = void 0;
function enumList(enumItem) {
    const result = [];
    for (const key in enumItem) {
        if ((enumItem.hasOwnProperty(key) &&
            Number(key).toString() !== key &&
            key !== 'displayName' &&
            typeof enumItem[key] === 'string') ||
            typeof enumItem[key] === 'number') {
            result.push(enumItem[key]);
        }
    }
    return result;
}
exports.enumList = enumList;
//# sourceMappingURL=enum.js.map